import { Component } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { Storage } from '@ionic/storage';
import { IonicPage, NavController, NavParams, PopoverController } from 'ionic-angular';

import { SingletonKlickhandlerService } from '../../services/klickhandler.service';
import { GlobalsSingleton } from '../../app/core/GlobalsSingleton';
import { eGENA_Rechtliches } from '../../visionet/Rechtliches';

import { GlobalConstants } from '../../app/core/GlobalConstants';


@IonicPage()
@Component({
	templateUrl: 'Datenschutz.html',
})
export class DatenschutzPage {

	datenschutzerklaerung : SafeHtml = ""; // Das wird dargestellt.

	constructor(public navCtrl: NavController, public navParams: NavParams, public klickhandlerSingleton : SingletonKlickhandlerService, public globals: GlobalsSingleton, public storage: Storage, public sanitizer: DomSanitizer) {
		this.storage.get(GlobalConstants.STORAGE_KEY_RECHTLICHES)
			.then((rechtliches : eGENA_Rechtliches) => {
				// Wir manipulieren die externen Links so, dass sie in einem separaten Browser-Fenster geöffneet werden
				this.datenschutzerklaerung = this.sanitizer.bypassSecurityTrustHtml(rechtliches?.Datenschutzerklärung.replace(/<a/gi, "<a target=\"_\" "));

			})
			.catch( (reason: any) => {
				this.datenschutzerklaerung = globals.translate("ERR.Keine Datenschutzerklärung vorhanden");
				console.error("Datenschutzerklärung ermitteln Fehler: " + reason);
			});
	}


	

	/**	=== Visionet(sl) ==========
	 *	Zurück zur Startseite
	 */
	goHome(event : UIEvent) : void {
		this.navCtrl.goToRoot( {
			animate : true,
			animation: "ios-transition"
			}
		);
	}

}



// WEBPACK FOOTER //
// ./src/pages/Datenschutz/Datenschutz.ts